<template>
  <div class="page-invoice">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <div id="invoice">
      <b-row>
        <b-col>
          <strong>National Association of RV Parks &amp; Campgrounds</strong> <br />
          9085 E. Mineral Circle, Suite 200 <br />
          Centennial CO 80112 <br />
          Phone: (800) 395-2267 / (303) 681-0401 <br />
          https://www.ohi.org <br />
          membership@arvc.org <br /><br /><br />
          <strong style="font-size: 1.5em">INVOICE</strong>
        </b-col>
        <b-col>
          <img src="/img/OHI-Logo.png" alt="The National Association of RV Parks and Campgrounds">
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3"><strong>Invoice Date</strong></b-col>
        <b-col md="9">{{item.Date}}</b-col>
      </b-row>
      <b-row>
        <b-col md="3"><strong>Invoice Due</strong></b-col>
        <b-col md="9">{{item.DueDate.substr(0, 10)}}</b-col>
      </b-row>
      <b-row>
        <b-col md="3"><strong>Invoice Number</strong></b-col>
        <b-col md="9">{{item.ArvcId}}</b-col>
      </b-row>
      <b-row>
        <b-col md="3"><strong>Customer</strong></b-col>
        <b-col md="9">{{item.Account}}</b-col>
      </b-row>
      <b-row style="margin-top: 40px; margin-bottom: 40px;">
        <b-col>

          <table class="table" id="invoiceLines">
            <thead>
              <tr>
                <th style="text-align: left;">Quantity</th>
                <th style="text-align: left;">Item</th>
                <th class="hide-sm" style="text-align: right;">List Price</th>
                <th style="text-align: right;">Sale Price</th>
                <th style="text-align: right;">Total</th>
              </tr>
            </thead>
              <tbody>
                <tr v-for="(line, index) in item.Lines" :key="index">
                  <td id="invoiceLineQuantity" style="text-align: left;">{{line.Quantity}}</td>
                  <td id="invoiceLineDescription" style="text-align: left;max-width: 290px">{{line.Description}}</td>
                  <td id="invoiceLineList" style="text-align: right">{{line.ListPrice}}</td>
                  <td id="invoiceLineSale" style="text-align: right">{{line.SalePrice}}</td>
                  <td id="invoiceLineTotal" style="text-align: right">{{line.Total}}</td>
                </tr>
              </tbody>
            <tfoot>
              <tr>
                <td colspan="3">&nbsp;</td>
                <td>Subtotal</td>
                <td id="invoiceSubtotal" style="text-align: right">{{item.Subtotal}}</td>
              </tr>
              <tr>
                <td colspan="3">&nbsp;</td>
                <td>Total</td>
                <td id="invoiceTotal" style="text-align: right">{{item.Total}}</td>
              </tr>
              <tr>
                <td colspan="3">&nbsp;</td>
                <td>Amount Paid</td>
                <td id="invoicePaid" style="text-align: right">{{item.Paid}}</td>
              </tr>
              <tr>
                <td colspan="3">&nbsp;</td>
                <td>Balance Due</td>
                <td id="invoiceBalance" style="text-align: right">{{item.Balance}}</td>
              </tr>
            </tfoot>
          </table>

        </b-col>
      </b-row>
      <b-row v-if="item.Memo">
        <b-col>
          <strong>Memo</strong><br />
          {{item.Memo}}<br /><br />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <strong>Payment Terms &amp; Conditions</strong><br />
          Thank you for your business. Payment is due within 30 days, so please process this invoice within that time. You can pay this invoice online by logging
          into your account and selecting the "Make a Payment" from the profile page. All major credit cards are accepted. If paying via check, please
          include your invoice number on the check and remit payment to:<br /><br />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <strong>
            National Association of RV Parks &amp; Campgrounds <br />
            9085 E. Mineral Circle, Suite 200 <br />
            Centennial, CO 80112 <br /><br /><br />
          </strong>
        </b-col>
      </b-row>
      <b-row class="d-print-none">
        <b-col>
          <b-button href="javascript:window.print()" variant="primary">Print</b-button>
        </b-col>
        <b-col>
          <b-button :href="`https://my.arvc.org/s/#/store/checkout/${item.SfId}`" v-if="item.Balance !== '$0.00'" variant="success" style="float:right;">Pay</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Invoice',
  data() {
    return {
      test: 'test',
      item: {},
    };
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawItems = await axios.get(`${server}/api/invoices`);
        if (rawItems.data.redirect) {
          window.location.href = rawItems.data.redirect;
          return;
        }
        this.item = rawItems.data.find((r) => r.Id === this.$route.params.id);
        console.log(this.item);
      } catch (err) {
        console.log({ listListingsError: err });
      }
    });
  },
};
</script>

<style lang="scss">
  #invoice { max-width: 1024px; }
  #invoice img { float: right; }
  #invoice .btn { min-width: 150px; }
</style>
